<div class="card">
    <app-header titulo="Pesagem" descricao="Dados das ordens de pesagens"></app-header>

    <p-table [value]="pesagens" dataKey="noOrdem" [loading]="loading" [resizableColumns]="true" [tableStyle]="{'font-size':'.9rem', 'font-weight':'400', 'border-spacing':'0 0 !important', 'border-colapse': 'separate'}"  #dt
             [lazy]="true" (onLazyLoad)="onLazyLoad($event)" [totalRecords]="totalRecords"
             styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines" [rowsPerPageOptions]="[20, 50, 100]" [paginator]="true" [rows]="20" [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros" [scrollable]="true" scrollHeight="40.5rem">
        <ng-template pTemplate="caption">
            <div class="flex">
                <button pButton pRipple icon="pi pi-refresh" (click)="recarregar()"></button>
                <button pButton pRipple (click)="sincronizarOrdens()" [loading]="loadingSincronizar" class="ml-3">Buscar Ordens do SAP</button>
                <span class="p-input-icon-left ml-auto">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="onBuscaInput($any($event.target)?.value)" placeholder="Pesquisar" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="instancia">Instância
                    <p-sortIcon field="instancia" />
                    <p-columnFilter field="instancia" matchMode="in" display="menu" [showApplyButton]="false" [showClearButton]="false" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                        
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback" >
                            <p-multiSelect [ngModel]="value" selectedItemsLabel="Vários selecionados" [options]="instancias" placeholder="Todos" [filter]="true"  optionValue="id" (onChange)="filter($event.value)" optionLabel="nome">
                                
                                <ng-template let-option pTemplate="item">
                                    <div class="inline-block vertical-align-middle">
                                        <span class="ml-1 mt-1">{{ option.nome }}</span>
                                    </div>
                                </ng-template>
                                
                            </p-multiSelect>
                        </ng-template>

                        <ng-template pTemplate="clearfiltericon">

                        </ng-template>
                    </p-columnFilter>
                </th>
                <th pSortableColumn="noOrdem">Ordem <p-sortIcon field="noOrdem" /></th>
                <th>Cód. Produto</th>
                <th>Produto</th>
                <th>Transportadora</th>
                <th>Destinatario</th>
                <th  pSortableColumn="dtIntegPims">Integ PIMS <p-sortIcon field="dtIntegPims" /></th>
                <th  pSortableColumn="dtIntegErp">Integ ERP <p-sortIcon field="dtIntegErp" /></th>
                <!-- <th pSortableColumn="fgStatusInteg">Status <p-sortIcon field="fgStatusInteg" /></th> -->
                 <th pSortableColumn="fgStatusInteg">
                    Status
                    <p-sortIcon field="fgStatusInteg" />
                    <p-columnFilter field="fgStatusInteg" matchMode="in" display="menu" [showApplyButton]="false" [showClearButton]="false" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                        
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback" >
                            <p-multiSelect [ngModel]="value" selectedItemsLabel="Vários selecionados" [options]="status" placeholder="Todos" [filter]="true"  optionValue="value" (onChange)="filter($event.value)" optionLabel="name">
                                
                                <ng-template let-option pTemplate="item">
                                    <div class="inline-block vertical-align-middle">
                                        <span class="ml-1 mt-1">{{ option.name }}</span>
                                    </div>
                                </ng-template>
                                
                            </p-multiSelect>
                        </ng-template>

                        <ng-template pTemplate="clearfiltericon">

                        </ng-template>
                    </p-columnFilter>
                 </th>
                <th>Mensagem</th>
                <th>Tanque</th>
                <th>Liberada</th>
                <th>Motorista</th>
                <th>CPF</th>
                <th>CNH</th>
                <th>Caminhão</th>
                <th>Reboque 1</th>
                <th>Reboque 2</th>
                <th>Reboque 3</th>
                <th>Bruto</th>
                <th>Tara</th>
                <th>Liquido</th>
                <th>Faturar</th>
                <th>Lacres</th>
                <th>Certificado</th>
                <th>Lacre Amostra</th>
                <th></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-pesagem>
            <tr>
                <td>{{ pesagem.instancia }}</td>
                <td>{{ pesagem.noOrdem }}</td>
                <td>{{ pesagem.cdProdutoErp }}</td>
                <td>{{ pesagem.deProduto }}</td>
                <td>{{ pesagem.deTransportadora.toUpperCase() }}</td>
                <td>{{ pesagem.deDestinatario }}</td>
                <td>{{ pesagem.dtIntegPims }}</td>
                <td>{{ pesagem.dtIntegErp }}</td>
                <!-- <b class="pi pi-check-circle text-green-500"></b> <b style="padding-left: .2rem" class="text-green-500">{{pesagem.fgStatusInteg}}</b>  -->
                <td><p-tag [icon]="getIcon(pesagem.fgStatusInteg)" [value]="pesagem.fgStatusInteg" [severity]="getSeverity(pesagem.fgStatusInteg)"></p-tag></td>
                <td>{{ pesagem.deMensagemInteg }}</td>
                <td>{{ pesagem.cdTanque }}</td>
                <td>{{ pesagem.qtLiberada?.toLocaleString("pt-BR") }}</td>
                <td>{{ pesagem.nomeMotorista }}</td>
                <td>{{ pesagem.cpfMotorista }}</td>
                <td>{{ pesagem.cnhMotorista }}</td>
                <td>{{ pesagem.placaCaminhao }}</td>
                <td>{{ pesagem.placaReboque1 }}</td>
                <td>{{ pesagem.placaReboque2 }}</td>
                <td>{{ pesagem.placaReboque3 }}</td>
                <td>{{ pesagem.qtBruto?.toLocaleString("pt-BR") || "" }}</td>
                <td>{{ pesagem.qtTara?.toLocaleString("pt-BR")  || ""}}</td>
                <td>{{ pesagem.qtLiquido?.toLocaleString("pt-BR")  || ""}}</td>
                <td>{{ pesagem.qtFaturar?.toLocaleString("pt-BR")  || ""}}</td>
                <td>{{ pesagem.lacres }}</td>
                <td>{{ pesagem.nroCertificado }}</td>
                <td>{{ pesagem.noLacreAmostra }}</td>
                <td><span (click)="exibirJson(pesagem)" style="cursor: pointer; color: darkblue;">JSON</span></td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <td colspan="10">Nenhum registro encontrado</td>
        </ng-template>
    </p-table>
</div>

<p-dialog 
    [header]="pesagemSelecionada.noOrdem"
    [(visible)]="visible" 
    [modal]="true" 
    [draggable]="false" 
    [resizable]="false"
    [maximizable]="true">
        <textarea 
    rows="5"
    cols="30" 
    pInputTextarea >
    {{ pesagemSelecionada.payload }}
</textarea>
</p-dialog>